import { animated } from 'react-spring';
import styled from 'styled-components';
import { Button } from '../button';
import { Position } from './tooltip';

export const TooltipBox = styled(animated.div)<{ position: Position }>`
  cursor: default;
  position: absolute;
  border-radius: ${({ theme }): string => theme.border_radius_x2};
  margin-left: -40px;
  width: fit-content;
  max-width: 300px;
  color: ${({ theme }): string => theme.palette_gray_100};
  background-color: ${({ theme }): string => theme.palette_blue_5};
  padding: ${({ theme }): string => theme.spacing_unit_x2};

  ${({ position }): { [key: string]: string } => {
    switch (position) {
      case 'bottom': {
        return { top: 'calc(100% + 10px)' };
      }
      case 'top': {
        return { bottom: 'calc(100% + 10px)' };
      }
      case 'right': {
        return {
          marginTop: '-10px',
          left: 'calc(100% + 50px)',
          top: '0'
        };
      }
      case 'left': {
        return {
          marginTop: '-10px',
          right: 'calc(100% + 10px)',
          top: '0'
        };
      }
      default:
        return {};
    }
  }};

  &:before {
    content: '';
    width: 0;
    height: 0;
    position: absolute;
    border: none;
    transition: border 0.3s ease-in-out;
    transform: rotate(45deg);
    ${({ position, theme }): { [key: string]: string } => {
      switch (position) {
        case 'bottom': {
          return {
            top: '-6px',
            left: '16px',
            border: `8px solid ${theme.palette_blue_5}`
          };
        }
        case 'right': {
          return {
            top: '16px',
            left: '-6px',
            border: `8px solid ${theme.palette_blue_5}`
          };
        }
        default:
          return {};
      }
    }};
  }

  &:after {
    content: '';
    width: 0;
    height: 0;
    position: absolute;
    border: none;
    transition: border 0.3s ease-in-out;
    transform: rotate(45deg);
    ${({ position, theme }): { [key: string]: string } => {
      switch (position) {
        case 'left': {
          return {
            top: '16px',
            right: '-6px',
            border: `8px solid ${theme.palette_blue_5}`
          };
        }
        case 'top': {
          return {
            bottom: '-6px',
            left: '18px',
            border: `8px solid ${theme.palette_blue_5}`
          };
        }
        default:
          return {};
      }
    }};
  }
`;

export const TooltipCard = styled(Button)`
  white-space: normal;
  width: 100%;
  color: ${({ theme }): string => theme.palette_blue_100};
  text-decoration: underline;
  display: flex;
  align-items: center;
  text-align: left;
  position: relative;
  height: 30px;
`;
